<template>
	<core-alerts v-if="canShowAlerts && outputErrors && error" :id="errorId" :alerts="alerts" />
	<core-loading v-else-if="connectLoading" :size="loaderSize" />
	<core-button v-else v-bind="$attrs" @click.prevent="handle"><slot>Connect</slot></core-button>
</template>

<script>
import { mapState } from 'vuex';
import { connect } from '@/components/mixins/connect';
export default {
	mixins: [connect],
	inheritAttrs: false,
	props: {
		outputErrors: {
			type: Boolean,
			default: true,
		},
		errorId: {
			type: String,
			default: 'om-connect-errors',
		},
		buttonClass: {
			type: String,
			default: '',
		},
		disconnect: {
			type: Boolean,
			default: false,
		},
		refreshAfter: {
			type: Boolean,
			default: true,
		},
		loaderSize: {
			type: String,
			default: '30px',
		},
	},
	data() {
		return {
			canShowAlerts: false,
		};
	},
	computed: {
		...mapState(['error', 'alerts']),
	},
	mounted() {
		this.$bus.$on('saveApiKeyFailed', this.allowShowAlerts);
		this.$bus.$on('saveApiKeySuccess', this.allowShowAlerts);
	},
	beforeDestroy() {
		this.$bus.$off('saveApiKeyFailed', this.allowShowAlerts);
		this.$bus.$off('saveApiKeySuccess', this.allowShowAlerts);
	},
	methods: {
		allowShowAlerts() {
			this.canShowAlerts = true;
		},
	},
};
</script>
